module.exports = __webpack_public_path__ + "assets/img/fomede_LIBER_pão.095185e2.png";